import { useState, useEffect } from 'react'
import detect from '@metamask/detect-provider'
import useIsMounted from '~hooks/useIsMounted'

async function getMetamaskProvider() {
    try {
        const metamaskProvider = await detect()

        return [metamaskProvider, null]
    } catch (e) {
        return [null, e]
    }
}

export default function useMetamaskProvider() {
    const [metamaskProvider, setMetamaskProvider] = useState(undefined)

    const isMounted = useIsMounted()

    useEffect(() => {
        (async () => {
            const [provider] = await getMetamaskProvider()

            if (isMounted()) {
                setMetamaskProvider(provider)
            }
        })()

        return () => {
            if (isMounted()) {
                setMetamaskProvider(undefined)
            }
        }
    }, [isMounted])

    return metamaskProvider
}
